export const storageInvoicePermissions = {
    MANAGE: {
        key: 'Storage.ManageInvoice',
        name: 'Approve storage invoices',
    },

}